import AOS from "aos";
import React, { useEffect } from "react";

const Skills = () => {
  useEffect(()=>{
    AOS.init({duration:3000});
  },[])
  return (
    <section data-aos="fade-up" id="about" className="pt-5">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="title-box text-center">
              <h3 className="title-a">Skills</h3>
              <div className="line-mf"></div>
            </div>
          </div>
        </div>
        <div className="row box-shadow-full">
          <div className="skill-mf col-md-9 offset-md-2">
            <span>JAVASCRIPT</span>
            <div className="progress" >
              <div
              data-aos="fade-right" 
                className="progress-bar bg-warning progress-bar-striped progress-bar-animated rounded"
                role="progressbar"
                aria-valuenow="96"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: "96%" }}
              >
                96%
              </div>
            </div>
            <span>REACT JS</span>
            <div className="progress">
              <div
              data-aos="fade-right" 
                className="progress-bar bg-warning progress-bar-striped progress-bar-animated rounded"
                role="progressbar"
                aria-valuenow="90"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: "90%" }}
              >
                90%
              </div>
            </div>
            <span>REACT Native</span>
            <div className="progress">
              <div
              data-aos="fade-right" 
                className="progress-bar bg-warning progress-bar-striped progress-bar-animated rounded"
                role="progressbar"
                aria-valuenow="60"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: "60%" }}
              >
                60%
              </div>
            </div>
            <span>NODE JS</span>
            <div className="progress">
              <div
              data-aos="fade-right" 
                className="progress-bar bg-warning progress-bar-striped progress-bar-animated rounded"
                role="progressbar"
                aria-valuenow="85"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: "85%" }}
              >
                85%
              </div>
            </div>
            <span>MongoDB</span>
            <div className="progress">
              <div
              data-aos="fade-right" 
                className="progress-bar bg-warning progress-bar-striped progress-bar-animated rounded"
                role="progressbar"
                aria-valuenow="80"
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: "80%" }}
              >
                80%
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
